export function setBanlistsLoading (state, loading = false) {
  state.banlistsLoading = loading
}

export function setBanlists (state, banlists) {
  state.banlists = banlists.data
  state.banlistsCurrentPage = banlists.current_page
  state.banlistsLastPage = banlists.last_page
  state.banlistsPerPage = banlists.per_page
  state.banlistsTotal = banlists.total
}

export function update (state, banlist) {
  const key = state.banlists.findIndex(o => o._id === banlist._id)
  state.banlists[key] = banlist
}

export function setSearch (state, search = '') {
  state.search = search
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
